export const DashboardSceneTranslation = {
  fi: {
    ServiceCallDashboardScene: {
      title: 'Huoltokutsuliittymä - Dashboard',
      tabReminders: 'Muistutukset',
      tabFaults: 'Vikailmoitukset',
      filterBusiness: 'Asiakasyritys',
      filterVehicle: 'Ajoneuvo',
      filterDateFrom: 'Alkaen',
      filterDateTo: 'Päättyen',
      filterStatus: 'Tila',
      filterAll: 'Kaikki',
      filterApply: 'Suodata',
      filterReset: 'Tyhjennä',
      filterActive: 'Suodatus päällä',
      filterResultCount: '{{count}} tulosta',
      businessName: 'Asiakasyritys',
      vehicle: 'Ajoneuvo',
      reminderTitle: 'Otsikko',
      dueDate: 'Eräpäivä',
      createdAt: 'Luotu',
      faultDescription: 'Kuvaus',
      status: 'Tila',
      statusOverdue: 'Myöhässä',
      statusOnTime: 'Ajallaan',
      statusOpen: 'Avoin',
      statusDone: 'Valmis',
      statusUnread: 'Uudet',
      statusRead: 'Luetut',
      unreadBadge: 'Uusi',
    },
    ServiceCallDashboardReminders: {
      title: 'Muistutukset',
    },
    ServiceCallDashboardFaults: {
      title: 'Vikailmoitukset',
    },
  },
};
